import type { GridBreakpoint } from './VirtualizedGridContainer.types';

const DEFAULT_BREAKPOINTS: GridBreakpoint[] = [
	{ min: 1700, cols: 7 },
	{ min: 1300, cols: 6 },
	{ min: 900, cols: 5 },
	{ min: 600, cols: 4 },
	{ min: 0, cols: 2 },
];

const DEFAULT_ESTIMATED_HEIGHT = 300;
const DEFAULT_OVERSCAN = 4;
const DEFAULT_GAP = 10;

export default {
	DEFAULT_BREAKPOINTS,
	DEFAULT_ESTIMATED_HEIGHT,
	DEFAULT_OVERSCAN,
	DEFAULT_GAP,
};
